var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "aiboxRef", staticClass: "yxtbiz-aibox" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.dataLoading,
            expression: "dataLoading",
          },
        ],
        staticClass: "container",
        class: { fullscreen: _vm.isFullscreen },
      },
      [
        _c("transition", { attrs: { name: "panel-slide" } }, [
          _vm.isFullscreen
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExpand,
                      expression: "isExpand",
                    },
                  ],
                  staticClass: "panel",
                },
                [
                  _c("div", { staticClass: "aibox-info" }, [
                    _c(
                      "div",
                      { staticClass: "app-info" },
                      [
                        _c("yxtf-portrait", {
                          staticClass: "portrait",
                          attrs: { size: "72px", imgUrl: _vm.appData.icon },
                        }),
                        _c("div", { staticClass: "app-name ellipsis" }, [
                          _vm._v(_vm._s(_vm.appData.appName)),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "option" }, [
                    _c("div", { staticClass: "option-left" }),
                    _c("div", { staticClass: "option-right" }, [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              _vm.isExpand = false
                            },
                          },
                        },
                        [
                          _c("yxtf-svg", {
                            staticClass:
                              "color-gray-7 hover-primary-6 hand icon",
                            attrs: {
                              width: "20px",
                              height: "20px",
                              "remote-url": _vm.ICON_PATH,
                              "icon-class": "shrink1",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isFullscreen && !_vm.isExpand,
                expression: "isFullscreen && !isExpand",
              },
            ],
            staticClass: "expand-btn hand",
            on: {
              click: function ($event) {
                _vm.isExpand = true
              },
            },
          },
          [
            _c("span", { staticClass: "text" }, [_vm._v("展开")]),
            _c("yxtf-svg", {
              attrs: {
                width: "20px",
                height: "20px",
                "remote-url": _vm.ICON_PATH,
                "icon-class": "expand1",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "main" },
          [
            _c("div", { staticClass: "header" }, [
              _c(
                "div",
                { staticClass: "left", class: { hidden: _vm.isFullscreen } },
                [
                  _c("yxtf-portrait", {
                    attrs: { size: "36px", imgUrl: _vm.appData.icon },
                  }),
                  _c("span", { staticClass: "app-name ellipsis" }, [
                    _vm._v(_vm._s(_vm.appData.appName)),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "right" }, [
                _c(
                  "span",
                  { on: { click: _vm.toggleFullscreen } },
                  [
                    _c("yxtf-svg", {
                      staticClass: "color-gray-7 hover-primary-6 hand icon",
                      attrs: {
                        width: _vm.iconSize,
                        height: _vm.iconSize,
                        "remote-url": _vm.iconUrl,
                        "icon-class": _vm.isFullscreen
                          ? "ai-window"
                          : "ai-screen",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "span",
                  { on: { click: _vm.onClose } },
                  [
                    _c("yxtf-svg", {
                      staticClass: "color-gray-7 hover-primary-6 hand icon",
                      attrs: {
                        width: _vm.iconSize,
                        height: _vm.iconSize,
                        "remote-url": _vm.iconUrl,
                        "icon-class": "ai-closed",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "yxtf-scrollbar",
              { staticClass: "chat-container", attrs: { fitHeight: "" } },
              [
                _c("chat-box", {
                  ref: "chatBoxRef",
                  attrs: {
                    showPortrait: _vm.isFullscreen,
                    loading: _vm.loading,
                    "chat-list": _vm.qaList,
                    "service-img": _vm.appData.icon,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "top-option",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "top-opt-btn icon-btn-status",
                              class: {
                                "icon-btn-active":
                                  slotProps.data.appraisement === 1,
                                "icon-btn-disabled":
                                  slotProps.data.appraisement === 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onFeedbackItem(slotProps, 1)
                                },
                              },
                            },
                            [
                              _c("yxtf-svg", {
                                attrs: {
                                  width: "20px",
                                  height: "20px",
                                  "remote-url": _vm.ICON_PATH,
                                  "icon-class": slotProps.data.appraisement
                                    ? "great"
                                    : "great-outline",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "top-opt-btn icon-btn-status",
                              class: {
                                "icon-btn-active":
                                  slotProps.data.appraisement === 2,
                                "icon-btn-disabled":
                                  slotProps.data.appraisement === 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onFeedbackItem(slotProps, 2)
                                },
                              },
                            },
                            [
                              _c("yxtf-svg", {
                                attrs: {
                                  width: "20px",
                                  height: "20px",
                                  "remote-url": _vm.ICON_PATH,
                                  "icon-class": slotProps.data.appraisement
                                    ? "bad"
                                    : "bad-outline",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "option",
                      fn: function (slotProps) {
                        return [
                          _c("div", { staticClass: "option-left" }, [
                            slotProps.data.showStaffservice &&
                            slotProps.index === _vm.qaList.length - 1
                              ? _c(
                                  "div",
                                  {
                                    class: { "font-size-16": _vm.isFullscreen },
                                  },
                                  [
                                    _c("span", { staticClass: "tips" }, [
                                      _vm._v(
                                        "抱歉，目前无法解答您的问题，您可以"
                                      ),
                                    ]),
                                    _c(
                                      "yxtf-link",
                                      {
                                        attrs: {
                                          type: "primary",
                                          underline: false,
                                        },
                                        on: { click: _vm.onStaffservice },
                                      },
                                      [_vm._v("转人工")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !slotProps.data.appraisement,
                                  expression: "!slotProps.data.appraisement",
                                },
                              ],
                              staticClass: "option-right",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "option-btn-mini icon-btn-status",
                                  class: {
                                    "icon-btn-active":
                                      slotProps.data.appraisement === 1,
                                    "icon-btn-disabled":
                                      slotProps.data.appraisement === 2,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFeedbackItem(slotProps, 1)
                                    },
                                  },
                                },
                                [
                                  _c("yxtf-svg", {
                                    attrs: {
                                      width: "20px",
                                      height: "20px",
                                      "remote-url": _vm.ICON_PATH,
                                      "icon-class": slotProps.data.appraisement
                                        ? "great"
                                        : "great-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "option-btn-mini icon-btn-status",
                                  class: {
                                    "icon-btn-active":
                                      slotProps.data.appraisement === 2,
                                    "icon-btn-disabled":
                                      slotProps.data.appraisement === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFeedbackItem(slotProps, 2)
                                    },
                                  },
                                },
                                [
                                  _c("yxtf-svg", {
                                    attrs: {
                                      width: "20px",
                                      height: "20px",
                                      "remote-url": _vm.ICON_PATH,
                                      "icon-class": slotProps.data.appraisement
                                        ? "bad"
                                        : "bad-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "customOption",
                      fn: function (slotProps) {
                        return [
                          slotProps.index === _vm.activeFeedbackIndex
                            ? _c("feekback-box", {
                                attrs: { loading: _vm.feedbackLoading },
                                on: {
                                  submit: function (tags, content) {
                                    return _vm.onSubmitFeedback(
                                      slotProps.data,
                                      tags,
                                      content
                                    )
                                  },
                                  cancel: function ($event) {
                                    _vm.activeFeedbackIndex = -1
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "customItem",
                      fn: function (slotProps) {
                        return [
                          slotProps.data.type === "tips"
                            ? _c("div", { staticClass: "chat-tips" }, [
                                _c("div", [
                                  _vm._v(
                                    "平台操作有疑问？我是您的智能AI助手，随时待命解答您的每一个操作问题！您可以尝试用下面的方法问我哦。"
                                  ),
                                ]),
                                _c("div", { staticClass: "tips-opt" }, [
                                  _c("div", [_vm._v("你可以试着这样问我：")]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tips-btn",
                                      on: { click: _vm.getExample },
                                    },
                                    [
                                      _c("yxtf-svg", {
                                        staticClass: "icon",
                                        staticStyle: { "margin-right": "8px" },
                                        attrs: {
                                          width: 16,
                                          height: 16,
                                          "remote-url": _vm.ICON_PATH,
                                          "icon-class": "refresh",
                                        },
                                      }),
                                      _vm._v(
                                        "\n                  换一换\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.exampleLoading,
                                        expression: "exampleLoading",
                                      },
                                    ],
                                    staticClass: "example-list",
                                    class: { "full-screen": _vm.isFullscreen },
                                  },
                                  _vm._l(
                                    _vm.exampleList,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "example-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSelectQuestion(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "example-text" },
                                            [_vm._v(_vm._s(item))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          slotProps.data.type === "staffservice"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("好的，请点击唤起客服")]
                                  ),
                                  _c(
                                    "yxtf-link",
                                    {
                                      class: {
                                        "font-size-16": _vm.isFullscreen,
                                      },
                                      staticStyle: { "margin-left": "12px" },
                                      attrs: {
                                        type: "primary",
                                        underline: false,
                                      },
                                      on: { click: _vm.onStaffservice },
                                    },
                                    [_vm._v("转人工")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("chat-input", {
              ref: "chatInputRef",
              attrs: { loading: _vm.loading },
              on: { send: _vm.onSubmit },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }